import { render } from "./Wordmark.vue?vue&type=template&id=3293cd65&scoped=true"
import script from "./Wordmark.vue?vue&type=script&lang=js"
export * from "./Wordmark.vue?vue&type=script&lang=js"

import "./Wordmark.vue?vue&type=style&index=0&id=3293cd65&lang=scss&scoped=true"

import exportComponent from "/nodeApps/scrawl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3293cd65"]])

export default __exports__